export enum Channel {
  Product = 'presence-product',
  Doc = 'presence-doc',
}

export const getChannelName = (channel: Channel, id: string) => `${channel}-${id}`;
